module.exports = __webpack_public_path__ + "img/5-insurance-zone-emergency-assist.88903fe8.jpg";